import { Component, OnInit } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivityManagementService } from '../activity-management.service';
import { ExportToCsv } from 'export-to-csv';
import { of } from 'rxjs';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-workshop',
  templateUrl: './workshop.component.html',
  styleUrls: ['./workshop.component.scss']
})
export class WorkshopComponent implements OnInit {
  locationUrl: string = window.location.origin;
  allWorkshop;
  dateTime = [];
  page: number = 1;
  pageSize: number = 12;
  collectionSize: number;
  search: string;
  isSearch: boolean = false;
  searchWorkshop: any = '';
  rows;

  column = [{
    field: 'WORKSHOP_ID',
    header: 'รหัส workshop',
    class: 'col'
  }, {
    field: 'WORKSHOP_NAME',
    header: 'ชื่อ workshop',
    class: 'col'
  }, {
    field: 'WORKSHOP_DATE',
    header: 'วัน เวลาที่จัด workshop',
    class: 'col-3'
  }, {
    field: 'WORKSHOP_COACH',
    header: 'จัดโดย',
    class: 'col'
  },
  {
    field: 'STATUS_PUBLIC',
    header: 'สถานะ',
    class: 'col'
  },
  {
    field: 'COUNT_REGIS',
    header: 'จำนวนผู้เข้าร่วม',
    class: 'col-1'
  }, {
    field: 'WORKSHOP_PRICE',
    header: 'ราคา',
    class: 'col-1'
  }, {
    field: 'EDIT',
    header: 'แก้ไข',
    class: 'col-1'
  }, {
    field: 'REGISTERED_LIST',
    header: 'รายชื่อ',
    class: 'col-1'
  }]


  constructor(
    private ActivityManagementService: ActivityManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.getAllWorkshop()
    this.gobalFunctionService.setTitle('การจัดการ Workshop');
  }

  addWorkshop() {
    window.open('/activity-management/workshop/manage-workshop?isEdit=false', '_blank');
  }

  getAllWorkshop() {
    this.ActivityManagementService.getAllWorkshop().pipe(
      tap(res => {
        this.allWorkshop = res.result;
        for (let i = 0; i < res.result.length; i++) {
          this.dateTime[i] = res.result[i].WORKSHOP_DATE;
        }
        // console.log(this.allWorkshop);

        this.refresh();
        // // console.log(this.dateTime);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe()
  }

  edit(wid) {
    // console.log(wid);

    window.open('/activity-management/workshop/manage-workshop?isEdit=true&workshop_id=' + wid, '_blank');
  }

  downloadWorkshop(id): void {
    this.ActivityManagementService.downloadWorkshop(id).pipe(
      map(res => {
        if (res.success) {
          const options = {
            filename: res.result.WORKSHOP_NAME,
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: res.result.WORKSHOP_NAME,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: ['ลำดับ', 'ชื่อ', 'นามสกุล', 'สถานะ', 'สังกัด', 'อีเมล']
          };

          const csvExporter = new ExportToCsv(options);

          csvExporter.generateCsv(res.result.LIST);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchWorkshop = [];
      this.allWorkshop.filter(workshop => {
        if (workshop.WORKSHOP_NAME.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchWorkshop.push(workshop)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchWorkshop = null;
      this.getAllWorkshop();
    }
  }

  refresh() {
    this.collectionSize = this.allWorkshop.length;
    this.rows = this.allWorkshop
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchWorkshop.length;
    this.rows = this.searchWorkshop
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
